<template>
  <div class="d-flex justify-content-center align-items-center pb-5 ml-5">
    <div class="connect-import-schema" />
  </div>
</template>

<script>
// TODO: Oleh: this is a temp solution. Should be replaced with single SVG icon
export default {
  name: "ConnectIcon",
};
</script>

<style lang="scss" scoped>
.connect-import-schema {
  height: 130px;
  max-width: 200px;
  width: 100%;
  background-image: url("@/assets/icons/connect-1.svg"),
    url("@/assets/icons/connect-2.svg");
  background-repeat: no-repeat;
  background-position: left bottom, 84px -15px;
  background-size: 130px auto, 130px auto;
}
</style>
